import { React, useState, useEffect, useMemo, useContext } from "react";
import axios from "../../api/axios";
import { GlobalContext } from "../../App";
import { toast } from "react-toastify";
import TopHeader from "./TopHeader";
import inprogress from "../../assets/images/in-progress.png";
import completed from "../../assets/images/completed.png";
import onhold from "../../assets/images/on-hold.png";
import open from "../../assets/images/open.png";
import uat from "../../assets/images/uat.png";
import handwave from "../../assets/images/wave.png";
import Select from "react-select";
import { FormGroup, Col, Label, Row } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { Box,IconButton, Tooltip,Button  } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { HiOutlineFilter, HiFilter } from "react-icons/hi";
import { ExportToCsv } from 'export-to-csv';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';

const Home = (props, args) => {
  var url = "/" + window?.location?.href?.split("/")?.[3];
  const navigate = useNavigate();
  const currentDate = new Date()?.toISOString()?.substr(0, 10)
  const [taskList, setTaskList] = useState([]);
  const [tempTaskList, setTempTaskList] = useState([]);
  const [levelData, setLevelData] = useState({
    level0List: [],
    level1List: [],
    level0: [],
    level1: [],
  });
  const { rolexModuleData, user_id, roles, userProfile,serialSequence } =
    useContext(GlobalContext);
  // For mATERIAL-REACT-tABLE cODE
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  // ------------------------------------------------------------- Get Task List ---------------------------------
  const getTaskList = (userTaskList) => {
    setIsLoading(true);
    axios
      ?.post("/getTaskList")
      ?.then((response) => {
        const taskData = response?.data?.[0]?.task_data;
        const filteredTaskList = taskData?.filter((data) => {
          const roleCondition =
            rolexModuleData?.find(
              (moduleData) =>
                url === moduleData?.description && moduleData?.create === 1
            ) || roles?.find((role) => role?.role_id === 1001);

          const ownershipCondition =
            data?.project_master?.[0]?.project_owner_id === user_id ||
            data?.milestone_master?.[0]?.milestone_owner_id === user_id;

          return (
            roleCondition ||
            ownershipCondition ||
            userTaskList?.includes(data?.task_id)
          );
        });

        setTaskList(filteredTaskList);
        setRowCount(filteredTaskList?.length);
        setTempTaskList(filteredTaskList);

        const level0List =
          filteredTaskList
            ?.filter(
              (obj, index, arr) =>
                arr?.findIndex((o) => o?.project_id === obj?.project_id) === index
            )
            ?.map((item) => ({
              label: item?.project_master?.[0]?.project_title,
              value: item?.project_id,
            })) || [];

        setLevelData({ ...levelData, level0List,level0:[],level1:[] });

        setIsError(false);
      })
      ?.catch((error) => {
        const statusCode = error?.response ? error?.response?.status : null;
        let errorMessage = "No getTaskList API Response !";
        if (statusCode === 500) {
          errorMessage = "getTaskList : Internal Server Error !";
        } else if (statusCode === 404) {
          errorMessage = "Page Not Found !";
        }
        toast?.error(errorMessage, {
          position: toast?.POSITION?.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        });
        setIsError(true);
      })
      ?.finally(() => {
        setIsLoading(false);
        setIsRefetching(false);
      });
  };

  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    axios
      ?.get("/getUserData")
      ?.then((response) => {
        const userTaskList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_task?.filter((data) => data?.task_access === 1)
          ?.map((data) => data?.task_id);
        getTaskList(userTaskList);
      })
      ?.catch((error) => {
        const statusCode = error?.response ? error?.response?.status : null;
        // Handle the error here based on the status code received
        if (statusCode === 500) {
          toast?.error("getUserData : Internal Server Error !", {
            position: toast?.POSITION?.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000,
          });
          // Handle 500 Internal Server Error
        } else if (statusCode === 404) {
          toast?.error("Page Not Found !", {
            position: toast?.POSITION?.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000,
          });
          // Handle 404 Not Found
        } else {
          toast?.error("No getUserData API Response !", {
            position: toast?.POSITION?.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000,
          });
          // Handle other error scenarios
        }
      });
  };
  
  // const getUserData = async () => {
  //   try {
  //     const UserListCriteria =
  //       roles?.find((data1) => data1?.role_id === 1001) ? "" : userProfile || "";
  //     const response = await axios.get(
  //       `/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`
  //     );

  //     const userTaskList = response?.data?.[0]?.user_data
  //       ?.filter((item) => item?.user_id === user_id)?.[0]
  //       ?.user_x_task?.filter((data) => data?.task_access === 1)
  //       ?.map((data) => data?.task_id);

  //     await getTaskCount(userTaskList);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };
  // --------------------------------------------------------- Filter Level 0 Task List ----------------------------
  const FilterLevel0TaskList = (Level0Data) => {
    const TaskList = tempTaskList?.filter(
      (item) => item?.project_id === Level0Data?.value
    );
    setTaskList(TaskList);
    const Level1List =
      TaskList?.filter(
        (obj, index, arr) =>
          arr?.findIndex((o) => o?.milestone_id === obj?.milestone_id) === index
      )?.map((item) => ({
        label: item?.milestone_master?.[0]?.milestone_title,
        value: item?.milestone_id,
      })) ?? [];
    setLevelData({
      ...levelData,
      level0: Level0Data,
      level1: [],
      level1List: Level1List,
    });
  };
  // --------------------------------------------------------- Filter Level 1 Task List ----------------------------
  const FilterLevel1TaskList = (Level1Data) => {
    setLevelData({ ...levelData, level1: Level1Data });
    const TaskList = tempTaskList?.filter(
      (item) => item?.milestone_id === Level1Data?.value
    );
    setTaskList(TaskList);
  };

  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Home",
      operationPerformed: "navigate to home screen",
    };
    axios?.post("/postLogHistory", param);
  };
  // -------------------------------------------------------- Use Effect -----------------------------------------

  useEffect(() => {
    getUserData();
    // postLogHistory();
  }, []);

  const updateTask = ({ values, table }) => {
    // if (taskData?.taskTitle === null || taskData?.taskTitle === "") {
    //   e.preventDefault();
    //   toast.error("Title is required!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // } else if (taskData?.taskOwner?.length <= 0) {
    //   e.preventDefault();
    //   toast.error("Please select team members!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // }
    // else if (taskData?.taskDesc === null || taskData?.taskDesc === "") {
    //   e.preventDefault();
    //   toast.error("Description is required!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // } else if (
    //   (taskData?.taskStartDate === null || taskData?.taskStartDate === "")
    // ) {
    //   e.preventDefault();
    //   toast.error("Start date is required!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // } else if (
    //   (taskData?.taskEndDate === null || taskData?.taskEndDate === "") 
    // ) {
    //   e.preventDefault();
    //   toast.error("End Date is required!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // } else if (
    //   taskData?.taskStartDate > taskData?.taskEndDate 
    // ) {
    //   e.preventDefault();
    //   toast.error("Task end date should be greater than start date!", {
    //     position: toast.POSITION.TOP_RIGHT,
    //     theme: "colored",
    //     autoClose: 2000,
    //   });
    // }
    //  else if (
    //   taskData?.taskStartDate < taskData?.milestoneStartDate 
    // ) {
    //   e.preventDefault();
    //   toast.error(
    //     `Task start date should be greater than or equal to milestone start date! ${taskData?.milestoneStartDate}`,
    //     {
    //       position: toast.POSITION.TOP_RIGHT,
    //       theme: "colored",
    //       autoClose: 2000,
    //     }
    //   );
    // } else if (
    //   taskData?.taskEndDate > taskData?.milestoneEndDate
    // ) {
    //   e.preventDefault();
    //   toast.error(
    //     `Task end date should be less than or equal to milestone end date! ${taskData?.milestoneEndDate}`,
    //     {
    //       position: toast.POSITION.TOP_RIGHT,
    //       theme: "colored",
    //       autoClose: 2000,
    //     }
    //   );
    // } else if (taskData?.taskEndDate < currentDate) {
    //   e.preventDefault();
    //   toast.error(
    //     `You cannot update the task details as the task end date is already passed!`,
    //     {
    //       position: toast.POSITION.TOP_RIGHT,
    //       theme: "colored",
    //       autoClose: 2000,
    //     }
    //   );
    // } else {
    //   let formData = new FormData();
    //   formData.append("user_id", user_id);
    //   // formData.append("taskId", serialSequence[3]?.project_seqence);
    //   formData.append("taskData", JSON?.stringify(taskData));
    //   formData.append("userProfile", JSON?.stringify(userProfile));
    //   axios
    //     .post("/postAddTask", formData)
    //     .then((response) => {
    //       if (response.status === 202) {
    //         e.preventDefault();
    //         toast.error("Task already exist!", {
    //           position: toast.POSITION.TOP_RIGHT,
    //           theme: "colored",
    //           autoClose: 2000,
    //         });
    //       } else {
    //         toast.success(
    //           `Task  ${
    //             taskData?.updateId != null ? "updated" : "created"
    //           } successfully!`,
    //           {
    //             position: toast.POSITION.TOP_RIGHT,
    //             theme: "colored",
    //             autoClose: 2000,
    //           }
    //         );
    //         setTaskData({
    //           projectId: null,
    //           milestoneId: null,
    //           taskTitle: null,
    //           taskDesc: null,
    //           taskStatus: { value: "In Progress", label: "In Progress" },
    //           TaskPrirority: { value: "High", label: "High" },
    //           TaskCompletionDate: null,
    //           taskStartDate: "",
    //           taskEndDate: "",
    //           taskOwner: [],
    //           updateId: null,
    //           milestoneStartDate: null,
    //           milestoneEndDate: null,
    //           projectStartDate: null,
    //           projectEndDate: null,
    //           taskCompletionPercentage: { value: "0", label: "0" },
    //           taskCode: null,
    //           projectStatus: null,
    //           milestoneStatus: null,
    //           projectOwnerId: null,
    //           milestoneOwnerId: null,
    //                     });
    //         getTaskList();
    //         window.location.href = "/task";
    //       }
    //     })
    //     .catch(handleError);
    // }
  };

  // Table Report
   const statusList = ["In Progress", "Near Completion", "Completed", "On Hold", "Dropped" ]; 
   const percentageList = [10,20,30,40,50,60,70,80,90,100];
  const columns = useMemo(
    () => [
      {
          accessorKey: "task_code",
          header: "Task Id",
          accessorFn: (row) => row.task_code || "-",
          className:"task-link",
          Cell: ({ cell }) =>  `${serialSequence[3]?.prefix}-${cell?.row?.original?.task_code}`,
        },
      {
        accessorKey: "task_title",
        header: "Task",
        accessorFn: (row) => row?.task_title || "-",
        className:"task-link",
        Cell: ({ cell }) => (
          <a
          onClick={() => navigate(`/task-detail?param1=${btoa(cell?.row?.original?.task_id)}`)}
            target="_blank" // Opens the link in a new tab
            rel="noopener noreferrer" // Recommended for security reasons
            // style={{textDecoration:"underline"}}
          >
            {cell?.row?.original?.task_title || "-"}
          </a>
        ),
      },      
      {
        accessorFn: (row) => row?.task_x_owner?.map(data => data?.name)?.join(", ") || "-",
        header: "Team Members ",
        enableEditing: false,
      },
      {
        accessorKey: "task_completion_percentage",
        header: "Completion (%)",
        accessorFn: (row) => row?.task_completion_percentage || "-",
        filterVariant: 'range-slider',
        filterFn: 'betweenInclusive',
        muiTableHeadCellFilterSliderProps: {
          marks: true,
          max: 100, 
          min: 0,
          step: 10,
          },
        editVariant: 'select',
        editSelectOptions: percentageList,
      },
      {
        accessorKey: "task_status",
        header: "Status",
        accessorFn: (row) => row?.task_status || "-",
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor:
                cell?.row?.original?.task_status === "In Progress"
                  ? theme?.palette?.primary?.main
                  : cell?.row?.original?.task_status === "Near Completion"
                  ? theme?.palette?.secondary?.main
                  : cell?.row?.original?.task_status === "Completed"
                  ? theme?.palette?.success?.main
                  : cell?.row?.original?.task_status === "On Hold"
                  ? theme?.palette?.warning?.main
                  : cell?.row?.original?.task_status === "Dropped"
                  ? theme?.palette?.error?.main
                  : theme?.palette?.primary?.main,
              borderRadius: "22px",
              color: "#fff",
              minWidth: "75px",
              maxWidth: "auto",
              p: "0.2rem 0.75rem",
              textAlign: "center",
            })}
          >
            {cell?.row?.original?.task_status || "-"}{" "}
          </Box>
        ),
        filterVariant: "select",
        filterSelectOptions: statusList,
        editVariant: 'select',
        editSelectOptions: statusList,
      },
      {
        accessorKey: "task_start_date",
        id: "task_start_date",
        header: "Start Date",
        enableEditing: false,
        accessorFn: (row) => row?.task_start_date || "-",
        Cell: ({ cell }) =>
          cell?.row?.original?.task_start_date
            ? new Date(cell?.row?.original?.task_start_date)?.toLocaleDateString(
                "en-GB"
              )
            : "-",
        filterFn: "lessThanOrEqualTo",
        sortingFn: "datetime",
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(newValue) => {
                column?.setFilterValue(newValue);
              }}
              slotProps={{
                textField: {
                  helperText: 'Filter Mode: Less Than',
                  sx: { minWidth: '120px' },
                  variant: 'standard',
                },
              }}
              value={column?.getFilterValue()}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorKey: "task_end_date",
        id: "task_end_date",
        header: "End Date",
        accessorFn: (row) => row?.task_end_date || "-",
        enableEditing: false,
        Cell: ({ cell }) =>
          cell?.row?.original?.task_end_date
            ? new Date(cell?.row?.original?.task_end_date)?.toLocaleDateString(
                "en-GB"
              )
            : "-",
        filterFn: "lessThanOrEqualTo",
        sortingFn: "datetime",
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(newValue) => {
                column?.setFilterValue(newValue);
              }}
              slotProps={{
                textField: {
                  helperText: 'Filter Mode: Less Than',
                  sx: { minWidth: '120px' },
                  variant: 'standard',
                },
              }}
              value={column?.getFilterValue()}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorKey: "task_expected_date",
        id: "task_expected_date",
        header: "Expected Date",
        enableEditing: false,
        accessorFn: (row) => row?.task_expected_date || "-",
        Cell: ({ cell }) =>
          cell?.row?.original?.task_expected_date
            ? new Date(
                cell?.row?.original?.task_expected_date
              )?.toLocaleDateString("en-GB")
            : "-",
        filterFn: "lessThanOrEqualTo",
        sortingFn: "datetime",
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(newValue) => {
                column?.setFilterValue(newValue);
              }}
              slotProps={{
                textField: {
                  helperText: 'Filter Mode: Less Than',
                  sx: { minWidth: '120px' },
                  variant: 'standard',
                },
              }}
              value={column?.getFilterValue()}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorKey: "task_completion_date",
        id: "task_completion_date",
        header: "Completion Date",
        enableEditing: false,
        accessorFn: (row) => row?.task_completion_date || "-",
        Cell: ({ cell }) =>
          cell?.row?.original?.task_completion_date
            ? new Date(
                cell?.row?.original?.task_completion_date
              )?.toLocaleDateString("en-GB")
            : "-",
        filterFn: "lessThanOrEqualTo",
        sortingFn: "datetime",
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(newValue) => {
                column?.setFilterValue(newValue);
              }}
              slotProps={{
                textField: {
                  helperText: 'Filter Mode: Less Than',
                  sx: { minWidth: '120px' },
                  variant: 'standard',
                },
              }}
              value={column?.getFilterValue()}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorFn: (row) => row?.created_user?.[0] ? `${row.created_user[0].name} (${row.created_user[0].username})` : "-",
        header: "Created By",
        enableEditing: false,
      },
      {
        accessorFn: (row) => row?.updated_user?.[0] ? `${row.updated_user[0].name} (${row.updated_user[0].username})` : "-",
        header: "Updated By",
        enableEditing: false,
      },
      

      //end
    ],
    []
  );
  // Export CSV File
  const csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    filename:`TaskReport-${currentDate}`,
    // title:`Task Report - ${currentDate}`,
    // showTitle:true,
    headers: ['Level 0','Level 1','Task ID','Task','Team Members','Completion(%)','Status','Start Date','End Date','Expected Completion Date','Completion Date','Created By','Updated By'] 
    // ['Level 0 Id', 'Level 0', 'Level 1 Id','Level 1','Project Id','Project','Task Id','Task','Team Members','Task Completion(%)','Task Status','Task Start Date','Task End Date','Task Completion Date'] 
  };
  
  
  const csvExporter = new ExportToCsv(csvOptions);

  const handleExportRows = (rows) => {
    const csvData = rows?.map((row) => [
      row?.original?.project_master?.[0]?.project_title || '-',
      row?.original?.milestone_master?.[0]?.milestone_title || '-', 
      serialSequence[3]?.prefix-row?.original?.task_code || '-',
      row?.original?.task_title || '-',
      row?.original?.task_x_owner?.map((data)=> data?.name)?.join(', ') || '-',
      row?.original?.task_completion_percentage || '-',
      row?.original?.task_status || '-',
      row?.original?.task_start_date || '-',
      row?.original?.task_end_date || '-',
      row?.original?.task_expected_date || '-',      
      row?.original?.task_completion_date || '-',
      row?.original?.created_user?.[0] ? `${row.original.created_user[0].name} (${row.original.created_user[0].username})` : "-",
      row?.original?.updated_user?.[0] ? `${row.original.updated_user[0].name} (${row.original.updated_user[0].username})` : "-"
  ]);
    csvExporter?.generateCsv(csvData);
  };
  const handleExportData = () => {
    const csvData = taskList?.map((row) => [
        row?.project_master?.[0]?.project_title || '-', 
        row?.milestone_master?.[0]?.milestone_title || '-',
        serialSequence[3]?.prefix-row?.task_code || '-',
        row?.task_title || '-',
        row?.task_x_owner?.map((data)=> data?.name)?.join(', ') || '-',
        row?.task_completion_percentage || '-',
        row?.task_status || '-',
        row?.task_start_date || '-',
        row?.task_end_date || '-',
        row?.task_expected_date || '-',      
        row?.task_completion_date || '-',
        row?.created_user?.[0] ? `${row.created_user[0].name} (${row.created_user[0].username})` : "-",
        row?.updated_user?.[0] ? `${row.updated_user[0].name} (${row.updated_user[0].username})` : "-"
    ]);
    csvExporter.generateCsv(csvData);
};

const fontAwesomeIcons = {
  FilterListIcon: (props) => <HiOutlineFilter/>,
  FilterListOffIcon: () => <HiFilter />
};

  return (
    <>
      <TopHeader
        breadCrumb={
          <li className="nav-item">
            <span>Home</span>
          </li>
        }
      />
      <div id="homepage" className="contentInnerWrap">
        {userProfile?.firstLoginStatus === "1" ? (
          <h3 className="text-center">
            <span>
              <img className="welcomeUser wave" src={handwave} alt="Handwave" />
            </span>
            Hi, <span style={{ color: "#e55353" }}> {userProfile.name}</span>
          </h3>
        ) : null}
        <div className="homepagewrap">
          <div className="dashboardSummary" style={{ clear: "both" }}>
            <h5>Task Status</h5>
            <div className="dashboard-summary-container">
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("In Progress")}`)}
              >
                <div className="dashboard-summary-value dashInProgress">
                  <div className="dashicon">
                    <img src={inprogress} alt="In Progress" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                      {taskList?.length > 0
                        ? taskList?.filter(
                            (data) => data?.task_status === "In Progress"
                          )?.length
                        : "0"}
                    </div>
                    <div className="title">In Progress</div>
                  </div>
                </div>
              </a>
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("Near Completion")}`)}
              >
                <div className="dashboard-summary-value dashUAT">
                  <div className="dashicon">
                    <img src={uat} alt="UAT" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                      {taskList?.length > 0
                        ? taskList?.filter(
                            (data) => data?.task_status === "Near Completion"
                          )?.length
                        : "0"}
                    </div>
                    <div className="title">Near Completion</div>
                  </div>
                </div>
              </a>
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("Completed")}`)}
              >
                <div className="dashboard-summary-value dashMilestone">
                  <div className="dashicon">
                    <img src={completed} alt="completed" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                      {taskList?.length > 0
                        ? taskList?.filter(
                            (data) => data?.task_status === "Completed"
                          )?.length
                        : "0"}
                    </div>
                    <div className="title">Completed</div>
                  </div>
                </div>
              </a>
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("On Hold")}`)}
              >
                <div className="dashboard-summary-value dashOnHold">
                  <div className="dashicon">
                    <img src={onhold} alt="on hold" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                      {taskList?.length > 0
                        ? taskList?.filter(
                            (data) => data?.task_status === "On Hold"
                          )?.length
                        : "0"}
                    </div>
                    <div className="title">On Hold</div>
                  </div>
                </div>
              </a>
              <a
                className="dashboard-summary-tile"
                onClick={() => navigate(`/task?status=${btoa("Dropped")}`)}
              >
                <div className="dashboard-summary-value dashOpen">
                  <div className="dashicon">
                    <img src={open} alt="open" />
                  </div>
                  <div className="dashcount">
                    <div className="count">
                      {taskList?.length > 0
                        ? taskList?.filter(
                            (data) => data?.task_status === "Dropped"
                          )?.length
                        : "0"}
                    </div>
                    <div className="title">Dropped</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="taskreport">
            <Row>
              <Col md={12}>
               <strong>Task Report</strong>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="projectTitle" style={{fontWeight:"bold"}}>Level 0 *</Label>
                  <Select
                    classNamePrefix="react-select"
                    className="single-select"
                    menuPlacement="bottom"
                    maxMenuHeight={200}
                    value={levelData?.level0}
                    onChange={(select) => FilterLevel0TaskList(select)}
                    options={levelData?.level0List}
                    // isMulti
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "rgba(2, 137, 255,.2)",
                        primary50: "rgba(2, 137, 255,.2)",
                        primary75: "rgba(2, 137, 255,.2)",
                        primary: "#0289ff",
                      },
                    })}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="projectTitle" style={{fontWeight:"bold"}}>Level 1 *</Label>
                  <Select
                    classNamePrefix="react-select"
                    className="single-select"
                    menuPlacement="bottom"
                    maxMenuHeight={200}
                    value={levelData?.level1}
                    onChange={(select) => FilterLevel1TaskList(select)}
                    options={levelData?.level1List}
                    // isMulti
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "rgba(2, 137, 255,.2)",
                        primary50: "rgba(2, 137, 255,.2)",
                        primary75: "rgba(2, 137, 255,.2)",
                        primary: "#0289ff",
                      },
                    })}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="mt-2">
              <MaterialReactTable
                columns={columns}
                enableStickyHeader
                data={taskList || ''}
                enableRowSelection
                initialState={{ showColumnFilters: false, density: 'compact' }}
                // manualFiltering
                // manualPagination
                // manualSorting
                // enableColumnFilterModes
                enableColumnOrdering
                enableGrouping
                enablePinning
                // enableRowActions
                muiToolbarAlertBannerProps={
                  isError
                    ? {
                        color: "error",
                        children: "Error loading data",
                      }
                    : undefined
                }
                muiTableHeadCellFilterTextFieldProps={{
                  sx: { m: "0.5rem 0", width: "100%" },
                  // variant: "outlined",
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <>
                  <Tooltip arrow title="Refresh Data">
                    <IconButton onClick={() => getUserData()}>
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                    <Box
                    sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                  >
                    <Button
                      color="primary"
                      disabled={taskList.length === 0}
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={handleExportData}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All Data
                    </Button>
                    {/* <Button
                      disabled={table.getPrePaginationRowModel().rows.length === 0}
                      //export all rows, including from the next page, (still respects filtering and sorting)
                      onClick={() =>
                        handleExportRows(table.getPrePaginationRowModel().rows)
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All Rows
                    </Button> */}
                    <Button
                      disabled={table.getRowModel().rows.length === 0}
                      //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                      onClick={() => handleExportRows(table.getRowModel().rows)}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Page Rows
                    </Button>
                    <Button
                      disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows
                    </Button>
                  </Box>
                  </>
                )}
                positionToolbarAlertBanner="bottom"
                onColumnFiltersChange={setColumnFilters}
                onGlobalFilterChange={setGlobalFilter}
                onPaginationChange={setPagination}
                onSortingChange={setSorting}
                rowCount={rowCount}
                icons={fontAwesomeIcons}
                state={{
                  columnFilters,
                  globalFilter,
                  isLoading,
                  pagination,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                  sorting,
                }}

                // enableEditing={(rolexModuleData?.find( (moduleData) => url === moduleData?.description && moduleData?.update === 1 ) || roles?.find((role) => role?.role_id === 1001)) ? true : false}
                onEditingRowCancel = {() => ''}
                onEditingRowSave={updateTask}
                // positionActionsColumn='last'
                editDisplayMode='row'
                getRowId={(row) => row.id}
                renderRowActions= {({ row, table }) => (
                  <Box sx={{ display: 'flex', gap: '1rem' }}>
                    <Tooltip title="Edit">
                      <IconButton onClick={() => table.setEditingRow(row)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
              />
            </Row>
          </div>
          {/* <div className="defaultImage">
            <img src={defaultReportImg} alt="Images" />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
